import UmbracoForm from '@stories/Components/UmbracoForm/UmbracoForm';
import * as React from 'react';
import S from './FormModal.styles';
import CloseSvg from '@img/icons/close.svg';
import Button from '@stories/Components/Global/Buttons/Button/Button';
import { FocusScope } from 'react-aria';
const FormModal = (props) => {
    const [showModal, setShowModal] = React.useState(false);
    const refModal = React.useRef(null);
    React.useEffect(() => {
        function checkIfClickedOutside(e) {
            if (showModal && refModal.current && !refModal.current.contains(e.target)) {
                setShowModal(false);
            }
        }
        document.addEventListener('click', checkIfClickedOutside);
        return () => {
            document.removeEventListener('click', checkIfClickedOutside);
        };
    }, [showModal]);
    if (!props.formConfig) {
        return null;
    }
    return (React.createElement(S.Container, null,
        React.createElement(S.ButtonContainer, null,
            React.createElement(Button, { buttonType: props.theme === 'light' ? 'default' : 'inverted', onClick: () => setShowModal(!showModal) }, props.buttonText ?? 'Contact Us')),
        React.createElement(S.FormModal, { "data-show-modal": showModal },
            React.createElement(S.FormModalInner, { ref: refModal },
                React.createElement(S.CloseBtn, { type: "button", onClick: () => setShowModal(false) },
                    React.createElement(CloseSvg, null),
                    React.createElement("span", null, "Close")),
                React.createElement(FocusScope, { contain: true, autoFocus: true, restoreFocus: true },
                    React.createElement(S.ContentContainer, null,
                        React.createElement(S.ContentInner, null,
                            React.createElement(S.ContentWrapper, null,
                                React.createElement(S.Title, null, props.title),
                                props.content && (React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }))),
                            React.createElement(S.FormWrapper, null,
                                React.createElement(UmbracoForm, { ...props.formConfig })))))))));
};
export default FormModal;
